<template>
  <div>
    <div class="common-header">
      <es-breadcrumb>
        <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
        <es-breadcrumb-item>{{ $t('支付结果') }}</es-breadcrumb-item>
      </es-breadcrumb>
    </div>
    <divided />
    <div class="result common-body">
      <div v-show="status === 'resolve'" class="result-title">
        <img src="../../assets/common/success.png" class="result-title-img" />
        <div class="result-text-success" v-if="sourceChannel === 28">
          <span class="result-title-tip">{{ $t('恭喜你下单支付成功') }}</span>
          <div>{{ $t('请立即添加官方企微，协助您上线生效套餐。') }}</div>
          <img class="weixin-img" :src="require('@/assets/images/qywx.png')" alt="" width="200" />
          <div>（{{ $t('首次添加另可以赠送证据报告一份，用于向对方说明电子合同有效性。') }}）</div>
        </div>
        <div class="result-text-success" v-else>
          <div class="result-title-tip">{{ $t('操作成功') }}</div>
          <div v-show="isOrg">{{ $t('若您尚未完成企业实名认证，该产品将无法正常启用') }}</div>
        </div>
        <div style="color: red; font-size: 14px">
          <span v-show="isDeliver">{{ $t('商品正在加紧备货，预计1-2周发出') }}</span>
        </div>
        <div v-show="$route.query.orderType !== 'charge'">
          <div style="display: flex">
            <div class="result-title-btn" @click="$router.replace('/MyOrder')" v-if="showOrderBtn !== 'false'">
              {{ $t('查看全部订单') }}
            </div>
            <div class="result-title-btn" @click="goBack" v-if="returnUrl" style="margin-left: 20px">{{ $t('返回') }}</div>
          </div>
        </div>
        <div v-show="$route.query.charge" style="margin-bottom: 70px">
          <div class="result-title-btn" @click="$router.push('/MyWallet')">{{ $t('查看余额') }}</div>
        </div>
      </div>
      <div v-show="status === 'reject'" class="result-title">
        <img src="../../assets/icons/buy_failed.svg" class="result-title-img" />
        <span class="result-title-tip">{{ $t('抱歉，支付失败！') }}</span>
        <span class="result-title-reason">{{ $t('失败原因：') }}{{ reason }}</span>
        <div style="margin-bottom: 70px">
          <div class="result-title-btn" @click="repay">{{ $t('重新支付') }}</div>
        </div>
      </div>
      <div v-show="status === 'pending'" class="result-title">
        <spin class="result-title-img"></spin>
        <span class="result-title-tip">{{ $t('请稍等，支付确认中…') }}</span>
        <div style="margin-bottom: 70px">
          <div class="result-title-btn" @click="mistake">{{ $t('支付遇到问题') }}</div>
        </div>
      </div>
      <div class="result-invoice" v-if="hasElecInvoice" v-show="status === 'resolve'">
        <div><img src="../../assets/icons/success.png" style="width: 12px; height: 12px" />&nbsp;{{ $t('电子发票已开') }}</div>
        <div>
          <span>{{ $t('发票抬头：') }}{{ userInfo.name }}</span>
          <span style="margin: 0 60px"
            >{{ $t('订单金额：')
            }}{{
              $t('{slot1}元', {
                slot1: money,
              })
            }}</span
          >
          <span style="color: rgba(24, 117, 240, 1); cursor: pointer" @click="jumpToEle">{{ $t('获取发票') }}</span>
        </div>
      </div>
      <div v-if="$route.query.orderId" style="width: 100%; box-shadow: 0 0 6px 0 #dce0ef">
        <es-table :data="orderList">
          <template slot="empty"
            ><es-empty
              style="margin: 25px; color: #999; line-height: 40px"
              :description="$t(`暂无更多数据`)"
              image="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAA/CAYAAABQHc7KAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA4XSURBVHgB7VtdkhxHEc6s7vlb7dqSZTlwEGDsCOMHeNCDD+Aj+AaYG8AJZE4AnABuwBXgAAQmghfzggWBDfphJe3uzOxOdyWZlZlV1btju1ux6yeVYjQ91dXVlf9fZtUiTGiPH5981LTtAyL6KHciEBChXvMXWZ804iuE3McNUR9INzD1pRF8jel+PS//+Gvs42/ffPPw93BDDccOfPLk7GMM+AdQshJRTEgmqEyI5Bcyiv9jygAyI/Qe+ZBEdM2w9KUXy+Uctuc7Gfnp3TurX8ENtDB2IDbwwC9lfYl4VKqE6MASzDSnL+EQKfHKLXvS6JM5KGKeE8qVaAP/R4t5C/Lhhx8cH28ewA200Qxguu4nSSMUiZschRmkTJHVm7wxq0URvEqcgGwONM5koSebSFph5rBczJgJM+wpfnoTTBjPAFT1JnINz/0mcp4MQ7Zj1Q7hC9m1NLN9MAsxe9FnastRBfK2XLSwWswhAl07EyZoALh6qooqAeQCTEJ0J0amJQhu1HZflcC0BAozlSU2avDtbbFQc4hED55eIxPG+wBEt93SqFp5Pc4jA5kdJMaF7OiylmR9qJ43LaNIV9Yg5sDaIObBTDj7HVxDG80AAg91VdjzVmmEhzob6yTSHjX3H5R9Atp71A/sXcdCfIIwAfCT62BCO3pkCWXoF6mLyQ0cAuZtAHRjxwIIzB4uixliJNxdRLFrG67+EDVqSpdPcKWJJkjjEClMgLt3bv0cXrKNZ0Dlqc3xJ2qbgPTa0QKLoxvfdvMIJ6fnBQ1lTUGKMX7jhNfFhElRgIbOTkWrDV6mtY0FDHUS+hYzg68zgbqpTxBG4M/YMb6UOYx3goMA5otFUWWW1rcvdl/bnnc5QtTQIoGqkTxVnCCOMX7y9H/rvxwf022Y0EabQA5xWJkCd4stHz/fwHzWgAEbBUEJ8IADfXHrSJXP75lphXGV04wgoc7xAYzRrsoc7kdY/5ovR5vDaN1l7tZBsCB7Q4DD5MZRHpRUSJ8qQEk7Bo5Onjfbp67rcLWaw62DFYxtkjfIp1kd/OjOCh+OeWZKGFQYS8U+HdZ6QpThsBGm48gygxTbscyXWgWLDf0xXhCtksvT0w2cnW1gjD+QJpqw4k93evoujGzTwmBaslFoxFB1k6pMd0BUxhCG/ausz02K6gTRIQIz48WLMzaxE88Rkq+UfjTXGUKQ/zgaNdA0jWnUeLKm+ACjH7PU9bffTn4LTRO8V/N8gzvV8PpJzM5ffkYynCGcielGANYKvhbnGC1R8hRb/IgmmTFNw4zgOx2MbVNwwIARGavzog5WLboj2tPG+pmcDW62O1b989QZmKA+9gK3hDvChDxlwV0qAFlazz6E+vFxeZoGYCUpWwUjQDxgZ3V9DdnxzeFsfSHZZcYf6l3bQdWIuWHVFBJTKGrVwui4PE0DiDLhYCWs/iUxwDc1mVIIooQzWOps31AJQMygLqFpBPIstSpEjGiToLAuATyVTe6w6/oEZyVn/9oHYb8d7Otn4mC93qVwKIQllU91hqhVKPYHQWw+aMzNjEHMq5tC1AQTyJxFK3Lkkud6c4Gbzc49OlitkLxmaGkEac5DNXSmYZI1vC41AXkmZHSIZHPL7KIpGjbdO09wgVMYYHCVCtjxCoYiILvp/VS+yxymNeBJD9p40qoSWUZYQSOPo5IdZBiWPRFa1LCVOPehH+0DJwAhfWFGer5Yd1CqjV4ENX6QW0tOovxmLoXZLYzVg+W5CFVENY0n8LEVMzNUp8u1iutiQJJFzE7HVwjmc6zeBUaXosW04KiSK8BJ1+tUGcnpV9SamSedTp3ddwLzLIkRrplQre9GcEDM9b6M2Nwbpti8zKGQqowBMxHVb1V8KoWQxEbMgz2pSF0lIVJCz3cd9H3l5ylLA9HTkgntZcKgvzi5naZBvHvnkGFolePcYBOpP3p8kpfixDvT5Gc/Yb4JPkBVGrPiauOKkBP/nTTRtvms9b0DS8jM9Kp1jZ5vymBheizORnJX3O0iq2SE76rJuxh7FILdeUbLUuXnhDg4CQqXeOMeOyUj9F9WSS2IXDYBL5BcamkbbZrH9ui4Y+Al6XIu00NxsAmdTkRCE4Yq9FTTd9NLTptTNHZOF132CyUoeEEob4G506qLIHnuPLbeME2xN5aSUYWcPAB4MuSZZYs3kAvoIhzNgSOeXNB1DSn1f19skbTvhBndpHsA2YRtLBhxjrozMtJOzwGo3pXOvE7DuJh0/dlgJSXXf4zV61X9arWmLPlc9Ua9RgtaBgiw4L30nDGLMpQuOKB4ekWaGZ3V2HFSmxQF0mujoreMAy0eFTQ2QHJIVVx24tO1JDu6XUaDqJ4jW3G2ThoVFATK4ECX1yhhsrsJIDRwWIPqTl6kOyZAxKEmgEdQgArk7Nv8GPxGj7z6QCqB+bNyXzPGYejD4XmNb22TK0Kg0RArkwMa2Lr5r2y66RKLturYtHg3Va9vYZF4LqUZXYYIE0uccT5m8MwE4gFeoiYILmnvT4mceW7voXwzL8z44lXj4uzKGwBoWCa/TM3Q1usUEIaJ0ARHMC0bhDrZqRZYO8eygpK9SZ3OEhfzFVD76cLQkk3GWOaseD/ICHWMQ4oyBia0CSbg3tzXVeK21wfU9uViuAbMEQSp5DxUS7rCC/ZM5XG0ulLe6espKu/hMdWJcUoyMK0kljPeErvMP9UaAkUxVNIxV4EIY4WaLx+N07AHBvG9BDgME3sWVQ5lGaNxgg1MKolBjUqyDVtOosgEsTr7V8YV5+fxXMcpuDICzHdibdMwRH/VpBXT8RJa7G5qX2A/dqfs+AGz7eaWK7V0yeGBn4QoP/2ReqxD5StroGImzqjJIQAmRoEkWqm/F0bYm/39hMMYCbWK15jWCMinzrKYc7gbaAHsZbwOLWaUiyc3lg3q9m0OgznuJw0sx+MuVYASw8z5UQVksAZC2YtVW2lVRSjzDK5qkkPSmmE3wIAyO3pNIJgEI9Xa6NVecMdUxWjLFzKzwMth5CluTYBqXbq6pAE5u/QTZ+mxEPT5tm1Hc2HC7rDuBlj4AaXD63+emg/qhkZihKoukJ8vxOWw6o/mSGNz7HGGEYfIWq1ONYqdYN+NDgOTKkJgoDfq6Q50vwA5Y8Mr45Uml1JJnKCkxjlqDHIdJc9tiSomeNbpwEo7Y82k8W0KEvyjvXnQWV+4VO1j/Mk4ppyjSPejHbaIWDHkEupLTpU81g8ZqLQ6Fqnf3zTLf8B1MwCb5tNCd1ZXyHXCYTUfXOUdutpOCeqmSIl4Lt2YGeFzRtcwtzejOCPLvBwwA1XOwm/ee+/OQ7huBrz/7r0/8XI/5pd8ZovMLhiKaHGoBc4oAzlZ6bPuZycGRZJkhORwOWC4H9MBQZgRPPTyGr5goP2LH7//vV/Cq/aqvWqv2sg2Pm+0xk6n/fJLmDfN6eHZ2fb2YkEHPbaHLeCbFHDeYnidXdltjn1vMFi4y1unSwY+C37yrSaEexwUD9iLrRi1Lfn1Cw0D8YI9+5qjyZYXtO6JHrGLe8x9W94J2iI2/4qxv2CguOX48B+GIC84rT7hyHrWUnd2cRGfP3++Pr9//0en/K4p5yP2M0CI/Pzzz1cHB3ePugaO8IJW7IGPePKGUeYKYLbiDbGDALhi/CnEcB8d8Ie/8YAh8orkHgKPgRU/x5/AfXQQeDy/IPXx/ZWWPuM5z79hZmx4QWd8vWWmbHgdG76/lmteljBow+9a9x1t+TEez0zr4yY0uIaeNr2MBdwAnm9DaHYMiE+322bTtuHknXduH++jNUPhhw+f3Wma3b0dhDf++eXTw9XRPey6DpqOh/DOd582fmRrmmXbRD22ZvE8QdCQejCkUrX8VGRWHfvPW+rBT4bo/VCAs54phoQD8t8gVVlj0HOBQXKykEoHoeFr3i9kYUCja5mxgGa9LBjaNyQt6Pnfw38/oYbw9ALjcdPNHjlDWiEcMf6Umm7Ry8I7LXv1TGzTNkJzwmBNwvUthAUSS0Bexf9Yron4BoIkOClVjgmgp58JCjmjSr2SLBX2I255n4jynkN69mpiFzPjLMeo7gXq+50oafrV8Fp77LChllIP86Nv6ZBXesRXP3z48NGGN3b/Hna0u98RLXvZTuJPKqe1QjBP0Olhm3Sv1eX0ZmHBMZSez3NdwCQKI6BqGaQTeVmQrvzBkDAlJN0K9hvSX5TUe89yajS/P50HshtCZVOywER89TvpelcKedA2K/78JNxaLP8G2G8b57csyvbWmvQUM0OIz30mC4xJtjJejvHJj3RY0TR6z/FBxLKPqBukVB+91Cb3opGsSp+8JFYc0Pc7W3xBvXDCpCMCZMkPCyNowhShynW/meHss/btt48ec/9jMYW+3b01a+a343n3GmSiWSu66j3c2cCM7a7Pi5EiiQg0arobgirpQLpCWAiOnE34WBB1qgnYd2D+8CZ4ml7IClWdoC6qQpRRYoHM9HRGgQXWxiysuvXsz2Zh+aLfxWecLT165/t31Qf4AHMK2VMKQ7o2Hi2oX7JIXkOcNx1crNgWZknVGxVRckChEaozwr8aXJwduf6vFQTyVKSkslHvsUJpuizf0aoNycGKXJwJTYPJ4vqIbgkhNnybOnbWJ7Dotm0PJ+s1nHzwwVubfSHypXDAF188OyS6WNB89XqD21szaG+FWXPU93TUNvj2btcv23Y2ZwH/gFe4ZKmtODzcaxDvgYQ/ogPu5xDIGEGTqC2lEEYS+tZMcdJKDn9bucfXT5nuY2bJM6L+OcvgnCPUE9p1Z227PGtfx2f9i8PTr7768+7DDz/cTaHn/7PXlClUi4fyAAAAAElFTkSuQmCC"
            ></es-empty>
          </template>
          <es-table-column :label="$t(`产品名称`)" prop="commodityName"></es-table-column>
          <es-table-column :label="$t(`订单编号`)" prop="showId"></es-table-column>
          <es-table-column :label="$t(`订单金额`)" prop="price"></es-table-column>
        </es-table>
      </div>

      <div class="result-tip" v-show="$route.query.invoiceId && status == 'resolve'">
        <span v-if="!hasElecInvoice">{{ $t('提示：您申请开具的发票将在7个工作日内寄出，请注意查收！') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import spin from '../../components/spin'
import { mapState } from 'vuex'
import divided from '../../components/divided'
export default {
  components: {
    spin,
    divided,
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
      mixScene: state => state.mixScene,
      isPartner: state => state.isPartner,
      showOrderBtn: state => state.showOrderBtn,
    }),
  },
  data() {
    return {
      isDeliver: false,
      hasElecInvoice: false,
      status: 'pending',
      clock: null,
      reason: '',
      orderList: [],
      money: '',
      returnUrl: localStorage.getItem('returnUrl') || '',
      sourceChannel: 0,
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.payOrderId) {
      next()
    } else {
      next('/MyOrder')
    }
  },

  mounted() {
    this.init()
    if (this.$route.query.orderId && this.$route.query.invoiceId) {
      this.$ajax(this.$url.invoicesSimpleinfo(this.$route.query.invoiceId)).then(res => {
        if (res.data && res.data[0].invoiceForm === 1) {
          this.hasElecInvoice = true
        }
      })
    }
  },
  methods: {
    getSourceChannel() {
      this.sourceChannel = Number(window.sessionStorage.getItem('source_channel')) || 0
    },
    uniteGoBack() {
      window.close()
    },
    goBack() {
      // 融合生态的场景
      if (this.mixScene) {
        this.uniteGoBack(this.mixScene)

        return
      }
      const url = localStorage.getItem('returnUrl') || ''
      const isContainParams = url.indexOf('?') === -1
      window.location.href = decodeURIComponent(`${url}${isContainParams ? '?' : '&'}orderId=${this.$route.query.orderId}`)
    },
    jumpToEle() {
      this.$router.push({
        path: '/ElecInvoice',
        query: {
          orderId: this.$route.query.orderId,
        },
      })
    },
    notify() {
      this.$notify({
        title: $t('警告'),
        message: $t('若您尚未完成企业实名认证，该产品将无法正常启用！'),
        type: 'warning',
      })
    },
    init() {
      this.getSourceChannel()
      this.status = 'pending'
      const { payOrderId } = this.$route.query
      if (payOrderId) {
        this.clock = setInterval(() => {
          this.$ajax(this.$url.getPayOrderDetail(payOrderId)).then(res => {
            if (res.data.status === 'PAY_SUCCESS') {
              this.status = 'resolve'
              clearInterval(this.clock)
              this.$reportBusiness('business_monitor_event_success', 'order_pay', {
                appId: this.$route.query.appid,
                ouid: this.userInfo.gid,
                orgId: this.userInfo.orgId,
                payOrderId,
                payStatus: res.data.status,
                stage: 'result',
              })
            } else if (res.data.status === 'PAY_AUDITING' || res.data.status === 'PAY_PENDING') {
              this.status = 'pending'
            } else {
              this.$reportBusiness('business_monitor_event_fail', 'order_pay', {
                appId: this.$route.query.appid,
                ouid: this.userInfo.gid,
                orgId: this.userInfo.orgId,
                payOrderId,
                payStatus: res.data.status,
                stage: 'result',
              })
              const { status } = res.data
              if (status === 'PAY_OUT_TIME') {
                this.reason = $t('用户取消')
              } else if (status === 'PAY_CANCEL') {
                this.reason = $t('超时取消')
              } else if (status === 'PAY_ABEND') {
                this.reason = $t('异常终止')
              } else {
                this.reason = res.data.status
              }
              this.status = 'reject'
              clearInterval(this.clock)
            }
          })
        }, 1000)
        if (this.$route.query.orderId) {
          this.$ajax(this.$url.getOrderdetail(), {
            payOrderId,
          }).then(res => {
            this.orderList = res.data.orders
            this.isDeliver = res.data.isDeliver
            let money = 0
            this.orderList.forEach(element => {
              money += element.price
            })
            this.money = money
          })
        }
      }
    },
    repay() {
      if (this.$route.query.orderType === 'charge') {
        this.$router.replace({
          path: '/MyWallet/Recharge',
          query: {
            ...this.$route.query,
          },
        })
      } else {
        this.$router.replace({
          path: '/RechargeOnline',
          query: {
            ...this.$route.query,
          },
        })
      }
    },
    mistake() {
      this.status = 'reject'
      this.reason = $t('支付失败')
      clearInterval(this.clock)
    },
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(this.clock)
    next()
  },
}
</script>
<style lang="less" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 60px;
  &-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    &-img {
      width: 60px;
      height: 60px;
      margin-bottom: 17px;
    }
    &-tip {
      color: #1a1a1a;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 7px;
    }
    &-reason {
      color: #999999;
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 13px;
    }
    &-btn {
      margin-top: 24px;
      margin-bottom: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 120px;
      height: 30px;
      background: #0975e0;
      color: white;
      font-size: 14px;
      cursor: pointer;
      border-radius: 3px;
    }
  }
  &-invoice {
    width: 100%;
    height: 80px;
    background: #f7f8fa;
    color: #232323;
    font-size: 14px;
    padding: 15px 24px;
    border-bottom: 1px dashed #ddd;
    box-shadow: 0px 0px 6px 0px #dce0ef;
    div:first-child {
      margin-bottom: 10px;
    }
  }
  &-tip {
    margin-top: 20px;
    color: #999999;
    font-size: 12px;
    line-height: 17px;
  }
}

.result-title {
  margin-bottom: 10px;
  .result-text-success {
    color: #1a1a1a;
    font-size: 14px;
    text-align: center;
    .weixin-img {
      margin: 20px 0 10px;
    }
  }
}
/deep/ .es-empty__image {
  width: 64px;
}
</style>
